import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color } from '../constants/color'
import { theme } from '../constants/theme'
import { StyleProps, createStyles } from '../utils/create-styles'

export const DESIGN_STYLE_MAP: Record<PaperDesign, StyleProps> = {
  blue: {
    backgroundColor: Color.LIGHTEST_BLUE,
    borderColor: Color.MEDIUM_LIGHT_BLUE,
  },
  white: {
    backgroundColor: Color.WHITE,
    borderColor: theme.color.border,
  },
  red: {
    backgroundColor: Color.LIGHTEST_RED,
    borderColor: Color.RED,
  },
  green: {
    backgroundColor: Color.TRANSPARENT_GREEN,
    borderColor: Color.GREEN,
  },
}

export type PaperDesign = 'green' | 'blue' | 'white' | 'red'

export type PaperProps = {
  children?: ReactNode
  design?: PaperDesign
  hideOverflow?: boolean
  styles?: StyleProps
}

/**
 * Inspired by the {@link https://mantine.dev/core/paper/ | Mantine documentation}:
 *
 * >Paper is the most basic ui component. Use it to create cards, dropdowns, modals and other
 * components that require background with shadow.
 */
export const Paper = styled.div<PaperProps>((props) => {
  const styles = DESIGN_STYLE_MAP[props.design ?? 'white']

  return {
    border: theme.border.style.thin,
    borderRadius: theme.border.radius.normal,
    boxShadow: theme.boxShadow.normal,
    overflow: props.hideOverflow ? 'hidden' : undefined,
    ...styles,
    ...createStyles(props.styles),
  }
})
